// covered-by: frontends/carrie/src/ask-v2/review/__tests__/reviewVersionOptions.test.ts
import { type ReviewVersionOption } from "./VersionPicker";

import { type ProjectReviewItem } from "../../services/askPunttProjectFeed.types";
import { isReviewItemFinished } from "../rail/collectRailContent";

/**
 * The lineage a review belongs to: the first review's id, shared by every
 * version christo linked to it (warhol spec kevin.johnson/0007), or the
 * review's own id when nobody linked it.
 */
function lineageOf(item: Pick<ProjectReviewItem, "id" | "lineageId">): string {
  return item.lineageId ?? item.id;
}

/**
 * The versions of the open review's artwork, oldest first: what the review
 * workspace's picker offers. A review nobody linked is a lineage of one, so
 * the picker disables itself; an open review the list does not carry offers
 * nothing, and the workspace falls back to the review itself.
 */
export function reviewVersionOptions(
  reviews: readonly ProjectReviewItem[],
  openReviewId: string | null | undefined,
): ReviewVersionOption[] {
  if (!openReviewId) return [];
  const open = reviews.find((item) => item.id === openReviewId);
  if (!open) return [];
  const lineage = lineageOf(open);
  return (
    reviews
      // why `isReviewItemFinished`: the picker offers what the rail can open,
      // and a strict `in_review` filter dropped the open version from its own
      // picker while its comments had already landed (AskV2ProjectPage).
      .filter(
        (item) => isReviewItemFinished(item) && lineageOf(item) === lineage,
      )
      .sort(
        (a, b) =>
          (a.versionNumber ?? Number.MAX_SAFE_INTEGER) -
          (b.versionNumber ?? Number.MAX_SAFE_INTEGER),
      )
      .map((item) => ({
        reviewId: item.id,
        title: item.title ?? item.name,
        versionNumber: item.versionNumber,
      }))
  );
}
